import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/our-story", label: "Our Story" },
  { to: "/the-problem", label: "The Problem" },
  { to: "/our-solution", label: "Our Solution" },
  { to: "/technology", label: "Technology" },
  { to: "/for-business", label: "For Business" },
  { to: "/sustainability", label: "Sustainability" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-deep text-cream mt-0">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20 sm:py-28">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 pb-16 border-b border-cream/10">
        <h2 className="font-display font-extrabold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-2xl">
          Let&rsquo;s keep the world&rsquo;s food{" "}
          <span className="font-serif italic font-medium text-mint">fresher, longer.</span>
        </h2>
        <Link
          to="/contact"
          data-testid="footer-cta-contact"
          className="inline-flex items-center gap-2 self-start lg:self-auto rounded-full bg-mint text-forest px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] transition-colors hover:bg-cream shrink-0"
        >
          Talk to us
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-10 py-14">
        <div className="col-span-2 md:col-span-1 flex flex-col gap-4">
          <span className="flex items-center gap-2.5">
            <img
              src="/fresh-guard-logo.png"
              alt="Fresh Guard logo"
              data-testid="footer-logo-mark"
              className="h-10 w-10 rounded-full bg-white object-cover"
            />
            <span className="font-display font-bold text-lg">Fresh Guard</span>
          </span>
          <p className="text-sm text-cream/60 leading-relaxed max-w-xs">
            A Saudi food technology company developing solutions to extend the natural shelf life of fresh
            vegetables and fruits.
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sage mb-5">Explore</p>
          <ul className="space-y-2.5">
            {NAV.slice(0, 4).map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-cream/70 hover:text-mint transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sage mb-5">Company</p>
          <ul className="space-y-2.5">
            {NAV.slice(4).map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-cream/70 hover:text-mint transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sage mb-5">Headquarters</p>
          <p className="text-sm text-cream/70 leading-relaxed">
            Riyadh, Kingdom of Saudi Arabia
          </p>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40">
            Aligned with Saudi Vision 2030
          </p>
        </div>
      </div>

      <div className="pt-8 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40">
          © 2026 Fresh Guard. All rights reserved.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40">
          Food science · Agricultural research · Smart packaging · Supply-chain intelligence
        </p>
      </div>
    </div>
  </footer>
);
